import { createApiClient } from "@hoteltradergit/user-management";

import { axiosInstance } from "./index";

// The user permissions bootstrap call (`getUserPermissions`) and first-login
// activation (`activateUser`) are served by the package's own API client, built
// from the shared axios instance. Consumers: PermissionContext.js, Callback.js.
//
// The client is built lazily (not at module load) because this module is pulled
// in transitively by the widely-imported PermissionContext. Deferring the
// `createApiClient` call keeps the module safe to import in tests that mock the
// package without providing `createApiClient`; the real call only runs when an
// endpoint is actually invoked.
const APP_ID = import.meta.env.VITE_PUBLIC_APP_ID || "supplier_portal";

let client = null;
const getClient = () => {
  if (!client) {
    client = createApiClient(axiosInstance, APP_ID);
  }
  return client;
};

export const userManagementApiClient = {
  getUserPermissions: () => getClient().getUserPermissions(),
  activateUser: () => getClient().activateUser(),
};
